import React from "react";

import { Creators, Footer } from "../../container";
import "../../App.css";

const TeamPage = () => {
    return (
        <div className="page">
            <Creators/>
            <Footer/>
        </div>
    );
};

export default TeamPage;